export const OtpVerificationTemplate = {
  pages: [
    {
      name: "page1",
      elements: [
        {
          type: "paneldynamic",
          name: "regionPhone",
          title: "Mobile Number",
          titleLocation: "top",
          isRequired: true,
          visibleIf: "true", //PHKL Custom
          templateElements: [
            {
              type: "dropdown",
              name: "regionCode",
              width: "36%",
              minWidth: "36%",
              maxWidth: "36%",
              startWithNewLine: false,
              allowClear: false,
              title: "Country Code",
              titleLocation: "hidden",
              isRequired: true,
              requiredErrorText: "Please select option where applicable",
              fieldType: "Standard",
              choices: ["+852", "+853", "+62"],
              modalConfig: {
                modalTitle: "Common.international_country_codes",
                showSearch: true,
              },
            },
            {
              type: "text",
              name: "phoneNumber",
              width: "64%",
              minWidth: "64%",
              maxWidth: "64%",
              startWithNewLine: false,
              titleLocation: "hidden",
              isRequired: true,
              textUpdateMode: "onTyping",
              placeholder: "Common.please_enter",
              requiredErrorText: "Common.please_enter",
              validators: [
                {
                  type: "expression",
                  text: "Common.please_input_real_phone",
                  expression:
                    "regionPhoneValidate({#regionPhone[0].regionCode},{regionPhone[0].phoneNumber})",
                },
              ],
              inputType: "tel",
            },
          ],
          allowAddPanel: false,
          allowRemovePanel: false,
          panelCount: 1,
          minPanelCount: 1,
          maxPanelCount: 1,
        },
        {
          type: "text",
          name: "otp",
          title: "Common.verify_code",
          isRequired: true,
          placeholder: "Common.please_enter",
          requiredErrorText: "Common.please_enter",
          textUpdateMode: "onTyping",
          visibleIf: "{regionPhone[0].phoneNumber.length} > 0",
          otpConfig: {
            position: "end",
            disabled: false,
            actionParams: {
              context: "FirstLogin",
              lang: "en",
              userType: "CANDIDATE",
              deliveryMethod: "SMS",
            },
          },
        },
        {
          type: "text",
          name: "otp",
          title: "Common.verify_code",
          isRequired: true,
          placeholder: "Common.please_enter",
          requiredErrorText: "Common.please_enter",
          textUpdateMode: "onTyping",
          visibleIf: "{regionPhone[0].phoneNumber.length} = 0",
          otpConfig: {
            position: "end",
            disabled: true,
            actionParams: {
              context: "FirstLogin",
              lang: "en",
              userType: "CANDIDATE",
              deliveryMethod: "SMS",
            },
          },
        },
      ],
    },
  ],
  showQuestionNumbers: "off",
};
